import { JSONObject } from 'global/graphql/scalars.type';
import { ActivitiesContentType } from 'global/constants';
import { Student } from 'approot/activity-builder/classroom/classroom.constants';
import { getStudentDisplayName } from 'approot/students/logic/get-student-display-name';
import { ActivityPrintMetadata } from '../activity-answers-print.constants';
import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';

type BaseLesson = {
  name: string;
  focusQuestion: {
    value: JSONObject | null;
  } | null;
  phenomena: {
    value: JSONObject | null;
  } | null;
  unit: {
    name: string;
  };
  subjects: {
    label: string;
  }[];
};

type BaseAssessment = {
  name: JSONObject | null;
  unit: {
    name: string;
  };
  subjects: {
    label: string;
  }[];
};

export function getPrintMetadata({
  contentType,
  lesson,
  assessment,
  landscapeImageUrls,
  className,
  student,
}: {
  contentType: ActivitiesContentType;
  lesson?: BaseLesson | null;
  assessment?: BaseAssessment | null;
  landscapeImageUrls: ResponsiveImage[];
  className: string;
  student?: Student;
}): ActivityPrintMetadata {
  return {
    unitName: lesson?.unit?.name || assessment?.unit?.name || '',
    subjectName:
      lesson?.subjects[0].label || assessment?.subjects[0].label || '',
    contentName: lesson?.name || assessment?.name || '',
    contentType,
    focusQuestion: lesson?.focusQuestion?.value,
    phenomena: lesson?.phenomena?.value,
    imageUrl: landscapeImageUrls?.[1]?.urls?.[0]?.url || '',
    userClassName: className,
    userName: student ? getStudentDisplayName(student) : '',
  };
}
